module.exports = __webpack_public_path__ + "static/img/delitang.fe52725.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/delitang.png
// module id = LrA9
// module chunks = 1